import API from "../api/axios";
import { saveToCache, loadFromCache } from "./cache";

export const fetchWithFallback = async (url, cacheKey) => {
  // If offline — read from cache immediately without attempting API
  if (!navigator.onLine) {
    const cached = loadFromCache(cacheKey);
    if (cached) {
      return { data: cached, fromCache: true };
    }
    return { data: null, fromCache: true };
  }

  // Online — try API first
  try {
    const res = await API.get(url);

    // Service worker returned offline error
    if (res?.offline || res?.data?.error === "offline") {
      const cached = loadFromCache(cacheKey);
      return { data: cached, fromCache: true };
    }

    // Valid response — save to cache and return
    if (res?.data) {
      saveToCache(cacheKey, res.data);
      return { data: res.data, fromCache: false };
    }

    // Null response — fall back to cache
    const cached = loadFromCache(cacheKey);
    return { data: cached, fromCache: true };

  } catch {
    // Network error — fall back to cache
    const cached = loadFromCache(cacheKey);
    return { data: cached, fromCache: true };
  }
};